import React from 'react';
import { Carousel, Typography } from 'antd';
import { carouselData } from '../data/mockData';

const { Title, Paragraph } = Typography;

const HeroSection = () => {
  const carouselStyle = {
    height: 'calc(100vh - 80px)',
    marginTop: '80px',
    overflow: 'hidden'
  };

  const slideStyle = {
    height: 'calc(100vh - 80px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1
  };

  const contentStyle = {
    maxWidth: '800px',
    padding: '40px',
    zIndex: 2,
    position: 'relative'
  };

  return (
    <section style={carouselStyle}>
      <Carousel 
        autoplay 
        autoplaySpeed={4000}
        effect="fade"
        dots={true}
        dotPosition="bottom"
        arrows={true}
      >
        {carouselData.map(slide => (
          <div key={slide.id}>
            <div 
              style={{
                ...slideStyle,
                backgroundImage: `url(${slide.backgroundImage})`
              }}
            >
              <div 
                style={{
                  ...overlayStyle,
                  background: slide.gradient
                }}
              />
              <div style={contentStyle}>
                <Title 
                  level={1} 
                  style={{ 
                    color: 'white', 
                    fontSize: '4rem', 
                    marginBottom: '20px', 
                    fontWeight: 'bold',
                    textShadow: '2px 2px 8px rgba(0,0,0,0.7)'
                  }}
                >
                  {slide.title}
                </Title>
                <Title 
                  level={2} 
                  style={{ 
                    color: 'rgba(255, 255, 255, 0.9)', 
                    fontSize: '2rem', 
                    marginBottom: '30px', 
                    fontWeight: 'normal',
                    textShadow: '1px 1px 4px rgba(0,0,0,0.7)'
                  }}
                >
                  {slide.subtitle}
                </Title>
                <Paragraph 
                  style={{ 
                    color: 'rgba(255, 255, 255, 0.85)', 
                    fontSize: '1.3rem', 
                    lineHeight: '1.8', 
                    marginBottom: '40px',
                    textShadow: '1px 1px 4px rgba(0,0,0,0.7)',
                    maxWidth: '700px',
                    margin: '0 auto 40px'
                  }}
                >
                  {slide.description}
                </Paragraph>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </section>
  );
};

export default HeroSection;